
import { Component, Vue } from "vue-property-decorator";
import Sidebar from '@/components/sidebar/Sidebar.vue';
import { Auth } from 'aws-amplify';

@Component({
	components: {
		Sidebar
	},
})
export default class Layout extends Vue {

	get username()
	{
		return this.$store.state.user.username;
	}

	async logout()
	{
		await Auth.signOut();
	}

	async handleUserDropdown(command: string)
	{
		if(command === "logout")
		{
			await this.logout();
		}
	}

}
